import api from "./base-api"
import {v4 as uuidv4} from "uuid";

const dsAnalyticalDataApiV1 = api.injectEndpoints({
    endpoints: (build) => ({
        getConsumablesV1DS: build.query({
            query: (
                data
            ) => {
                return `v1/ds/analytical-data/${data.userId}/consumables?limit=${data.limit}&page=0&from=${data.from}&to=${data.to}`
            },
            transformResponse: (response) => {
                const rows = response.map((row) => ({id: uuidv4(), ...row}));
                return {rows};
            },
        }),
        getEnvironmentsV1DS: build.query({
            query: (
                userId = "",
                limit = 5,
                page = 0
            ) => `v1/ds/analytical-data/${userId}/environments?limit=${limit}&page=${page}`
        }),
        getLevelsV1DS: build.query({
            query: (
                userId = "",
                limit = 100,
                page = 0
            ) => `v1/ds/analytical-data/${userId}/levels?limit=${limit}&page=${page}`
        }),
        getPaymentsV1DS: build.query({
            query: (
                userId = "",
                limit = 100,
                page = 0
            ) => `v1/ds/analytical-data/${userId}/payments?limit=${limit}&page=${page}`
        }),
        getSpendItemsDS: build.query({
            query: (
                data
            ) => `v1/ds/analytical-data/${data.userId}/spendItems?limit=${data.limit}&page=${data.page}`
        }),
        getPurchaseDS: build.query({
            query: (data) => {
                const params = new URLSearchParams({
                    payload: data.payload,
                    from: data.from,
                    to: data.to,
                    limit: data.limit ?? 100,
                })
                if (data.lastId != null) params.set("lastId", data.lastId)
                if (data.lastTimestamp != null) params.set("lastTimestamp", data.lastTimestamp)
                return `v1/ds/analytical-data/${data.userId}/purchases?${params}`
            }
        }),
        getPurchaseItemsDS: build.query({
            query: (
                data
            ) => `v1/ds/analytical-data/${data.userId}/purchaseItems?limit=${data.limit}&page=${data.page}`
        }),
        getSpendGroupItemsDS: build.query({
            query: (
                data
            ) => `v1/ds/analytical-data/${data.userId}/spendGroup`
        }),
        getBattlesV1DS: build.query({
            query: (
                userId = "",
                limit = 100,
                page = 0
            ) => `v1/ds/analytical-data/${userId}/battles?limit=${limit}&page=${page}`
        }),
        getPurchasesV1DS: build.query({
            query: (
                userId = "",
                limit = 100,
                page = 0
            ) => `v1/ds/analytical-data/${userId}/purchases?limit=${limit}&page=${page}`
        }),
        getUserInfoV1DS: build.query({
            query: (
                userId = "",
                limit = 100,
                page = 0
            ) => `v1/ds/analytical-data/${userId}/user-info?limit=${limit}&page=${page}`
        }),
    }),
    overrideExisting: false
})

export const {
    useGetConsumablesV1DSQuery,
    useGetEnvironmentsV1DSQuery,
    useGetUserInfoV1DSQuery,
    useGetLevelsV1DSQuery,
    useGetPaymentsV1DSQuery,
    useGetSpendGroupItemsDSQuery,
    useGetPurchaseDSQuery,
    useGetPurchaseItemsDSQuery,
    useGetSpendItemsDSQuery,
    useGetBattlesV1DSQuery,
    useGetPurchasesV1DSQuery
} = dsAnalyticalDataApiV1
